import { connect } from 'react-redux';
import { getCurrentAdSafety } from '../../../../Ads/redux/selectors';
const mapStateToProps = (state)=>({
        adSafety: getCurrentAdSafety(state) || ''
    });
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
